import { render, staticRenderFns } from "./ModalSelecionarOrgaoGerenciador.vue?vue&type=template&id=6e2b185b&scoped=true"
import script from "./ModalSelecionarOrgaoGerenciador.vue?vue&type=script&lang=js"
export * from "./ModalSelecionarOrgaoGerenciador.vue?vue&type=script&lang=js"
import style0 from "./ModalSelecionarOrgaoGerenciador.vue?vue&type=style&index=0&id=6e2b185b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2b185b",
  null
  
)

export default component.exports